<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          title="物流カレンダーメンテナンス"
          icon="dashboard"
          class="masterShipHoliday-header" />
      <span class="action_button">
        <div class="edit-button-wrap">
          <el-dropdown
              v-show="showActionButtonComponent"
              @command="actionCommand">
            <el-button size="small">
              アクション
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu
                slot="dropdown"
                class="header-action-menu">
              <el-dropdown-item
                  :disabled="$isFunctionDisabled(define.PermissionKeys.Ship.LogisticsCalendar.EDIT)"
                  :command="define.LOGISTICS_CALENDAR_MODE.EDIT">
                編集
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <BaseButton v-show="showEditButton"
              @click="cancel()">
            キャンセル
          </BaseButton>
          <BaseButton v-show="showEditButton"
              :disabled="disableSaveButton"
              @click="save()">
            保存
          </BaseButton>
        </div>
      </span>
    </el-row>
    <div class="base-search-condition-modal">
      <el-row class="search-box">
        <div>
          <label class="selector-title">
            サイト
          </label>
          <el-select v-model="siteCodeStr"
              :disabled="disabled"
              @change="onChangeSite">
            <el-option
                v-for="item in siteOpts"
                :key="item.code"
                :label="item.name"
                :value="item.code" />
          </el-select>
        </div>
        <div>
          <label class="selector-title">
            配送方法
          </label>
          <el-select v-model="shippingMethodStr"
              :disabled="disabled">
            <el-option
                v-for="item in shippingMethodsOpts"
                :key="item.name"
                :label="item.name"
                :value="item.name" />
          </el-select>
        </div>
        <div>
          <label class="selector-title">
            年月
          </label>
          <el-date-picker
              v-model="ym"
              style="display:block"
              type="month"
              placeholder="日付を選択してください"
              :disabled="disabled" />
        </div>
        <div>
          <label style="visibility:hidden">
            検索
          </label>
          <el-button
              v-show="showSearchButton"
              style="display:block"
              type="primary"
              @click="search">
            検索
          </el-button>
        </div>
      </el-row>
      <el-row>
        <div>
          <el-col>
            <div v-show="showCalandaButtonComponent"
                class="wrap">
              <div class="dateCalendar">
                <span>{{ dateCalendar.substring(0,4) }} 年 {{ dateCalendar.substring(5,6) === "0" ? dateCalendar.substring(6,7) : dateCalendar.substring(5,7) }} 月 </span>
              </div>
              <div class="weeks">
                <span>日</span>
                <span>月</span>
                <span>火</span>
                <span>水</span>
                <span>木</span>
                <span>金</span>
                <span>土</span>
              </div>
              <div id="dates" />
              <template v-for="(item, index) in calendarList">
                <span v-if="item.isActive !== 2"
                    :key="index"
                    :class="[item.color === 1 ? 'table_span_row un_click_color' : item.color === 2 ? 'table_span_row normal' : 'table_span_row backnormal']"
                    @click="onButtonClick(item,index)">
                  <el-button type="text">
                    {{ item.name }}
                  </el-button>
                </span>
                <br v-if="item.isActive === 2"
                    :key="index+100">
              </template>
            </div>
          </el-col>
          <el-col class="btn-list">
            <div class="add-row">
              <el-button v-show="showEditButton"
                  @click="addRow()">
                追加
              </el-button>
            </div>
          </el-col>
        </div>
      </el-row>
    </div>
    <div class="base-table-list tab-list">
      <div class="el-table">
        <div class="el-table__header-wrapper">
          <table
              ref="table"
              class="table"
              cellspacing="0.5">
            <thead>
              <tr class="header">
                <th class="is-leaf width-25">配送方法</th>
                <th class="is-leaf width-25">休業日</th>
                <th class="is-leaf width-50">備考</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(val, index) in holidayList">
                <tr v-if="val.node.isActive !== 0"
                    :key="index"
                    :data-id="`${index}`"
                    :class="{ 'un_d6_color': val.node.backColor == '1',
                              'un_d7_color': val.node.backColor == '2',
                              'un_d_color': val.node.backColor == '0'}">
                  <td>
                    <BaseCell
                        :ref="`shippingMethodCode_${index}`"
                        :properties="createTextAreaProp('shippingMethodCode')"
                        :display-item="val.node"
                        :disabled="true" />
                  </td>
                  <td>
                    <BaseCell
                        :ref="`holidayAt_${index}`"
                        :properties="createTextAreaProp('holidayAt')"
                        :display-item="val.node"
                        :disabled="true" />
                  </td>
                  <td>
                    <div class="div-flex">
                      <BaseCell
                          :ref="`note_${index}`"
                          :properties="createTextAreaProp('note')"
                          :display-item="val.node"
                          class="width-90"
                          :editable="mode === define.LOGISTICS_CALENDAR_MODE.EDIT" />
                      <BaseOperationTooltip
                          v-if="showTooltip"
                          :list="getTooltipList(index)"
                          class="operation-button"
                          placement="bottom-end" />
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tr v-if="holidayList.length < 1">
              <td colspan="3"
                  class="td-empty">
                データなし
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .btn-list {
    position: absolute;
    margin-left: 17%;
    margin-top: 260px;
  }
  .add-row {
    text-align: left;
  }
  .table {
    width: 100%;
  }
  .hidRow {
    display: none;
  }
  .td-empty {
    text-align: center !important;
    color: #909399 !important;
  }
  .div-flex {
    display: flex;
    justify-content: space-between;
  }
  .cell-msg {
    color: #e22908;
    text-align: right;
    margin-right: 10px;
  }
  .width-25 {
    width: 25%;
  }
  .width-50 {
    width: 50%;
  }
  .width-90 {
    width: 90%;
  }
  .wrap {
    font-size: 0;
  }
  .dateCalendar {
    padding-top: 15px;
  }
  .dateCalendar span {
    display: inline-block;
    font-size: 16px;
    width: 15.7%;
    height: 44px;
    line-height: 44px;
    border: 1px solid #EFEFEF;
    text-align: center;
  }
  .weeks span {
    display: inline-block;
    font-size: 14px;
    width: 2.15%;
    height: 32px;
    line-height: 32px;
    border: 1px solid #EFEFEF;
    text-align: center;
    }
  .table_span_row{
    font-size: 14px;
    display: inline-block;
    width:2.15%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #EFEFEF;
 }
  .un_click_color{
    background: #d4d0d0;
  }
  .backnormal{
    background: #FFFFFF;
  }
  .normal{
    background: rgb(189, 215, 238);
  }
  .un_d_color{
    background: #fcfbf9 !important;
  }
  .un_d_color .el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td{
    background: transparent;
  }
  .un_d7_color{
    background: rgb(252, 228, 214) !important;
  }
  .un_d7_color .el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td{
    background: transparent;
  }
  .un_d6_color{
    background: rgb(221, 235, 247) !important;
  }
  .un_d6_color .el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td{
    background: transparent;
  }
</style>
<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import * as define from '@/define'
import * as query from '@/queries/ship'
import common from '@/utils/common'
import compare from '@/utils/compareUtils'
import * as config from '@/config'
import message from '@/utils/message'
import moment from 'moment'

import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'
import BaseCell, { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseOperationTooltip from '@/components/molecules/BaseOperationTooltip'
import BaseButton from '@/components/atoms/BaseButton'
import BaseHeader from '@/components/molecules/BaseHeader'
import detailUtil from '@/components/mixins/detailUtil'

export default {
  name: 'MasterLogisticsCalendarList',
  components: {
    BaseHeader,
    BaseCell,
    BaseButton,
    BaseOperationTooltip
  },
  mixins: [ x, confirmDiscardOnLeave, detailUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      isChanged: false,
      holidayList: [],
      originHolidayList: [],
      disabled: false,
      calendarList: [],
      dateCalendar: '',
      ym: '',
      siteCodeStr: '',
      shippingMethodStr: null,
      siteOpts: [],
      shippingMethodsOpts: []
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      mode: (state) => state.MasterLogisticsCalendar.mode,
      siteCode: (state) => state.MasterLogisticsCalendar.siteCodeStore,
      shippingMethod: (state) => state.MasterLogisticsCalendar.shippingMethodStore,
      holidayAt: (state) => state.MasterLogisticsCalendar.holidayAtStore,
      tdLists: (state) => state.MasterLogisticsCalendar.tdLists,
      sites: (state) => state.sites
    }),
    ...mapGetters({
    }),

    storePath () {
      return 'MasterLogisticsCalendar'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_SHIPPING_METHODS_LIST
    },
    listQuery () {
      return query.GRAPH_QL_QUERY_SHIP_HOLIDAY_LIST
    },
    showActionButtonComponent () {
      return (this.showActionButton && (this.$isFunctionShown(define.PermissionKeys.Ship.LogisticsCalendar.EDIT)))
    },
    showCalandaButtonComponent () {
      return this.mode !== define.LOGISTICS_CALENDAR_MODE.NORMAL
    },
    showTooltip () {
      return this.mode !== define.LOGISTICS_CALENDAR_MODE.NORMAL
    },
    showActionButton () {
      return this.mode === define.LOGISTICS_CALENDAR_MODE.NORMAL
    },
    showEditButton () {
      return this.mode !== define.LOGISTICS_CALENDAR_MODE.NORMAL
    },
    showSearchButton () {
      return this.mode === define.LOGISTICS_CALENDAR_MODE.NORMAL
    },
    disableSaveButton () {
      return !this.isChanged
    },
    editableValidIds () {
      return this.mode !== define.LOGISTICS_CALENDAR_MODE.NORMAL
    }
  },
  watch: {
    holidayList: {
      handler: function (val, oldVal) {
        this.isChanged = this.$_ConfirmDiscardOnLeave_isChanged()
      },
      deep: true
    },
    mode: {
      handler: function (val, oldVal) {
        if (oldVal != null) {
          if (val === define.LOGISTICS_CALENDAR_MODE.EDIT) {
            // 編集モードに切り替える場合
            this.originHolidayList = _.cloneDeep(this.holidayList)
            this.$_ConfirmDiscardOnLeave_watchStart(this.holidayList)
          } else {
            // 通常モードに切り替える場合
            this.$_ConfirmDiscardOnLeave_watchEnd()
          }
        }
      },
      deep: true
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      // 選択肢（サイト）のリストを取得する
      this.sites.forEach(item => {
        if (item.type === 2) {
          this.siteOpts.push({
            code: item.code,
            name: item.name
          })
        }
      })
      if (this.siteOpts.length > 0) {
        this.siteCodeStr = this.siteOpts[0].code
      }
      // 選択肢（配送方法）のリストを取得する
      // 配送方法を取得する
      const queryQL = common.addGraphQlCondition(this.baseQuery, { siteCodes: [ this.siteCodeStr ] })
      // 配送方法検索APIを呼び出す
      const shippingMethods = await common.postGraphQl(queryQL)
      const methodList = shippingMethods.data.data.shippingMethods
      this.shippingMethodsOpts.push(
        {
          name: 'すべて'
        })
      methodList.forEach(item => {
        this.shippingMethodsOpts.push(
          {
            name: item.shippingMethod
          })
      })
      this.shippingMethodStr = this.shippingMethodsOpts[0].name

      // 選択肢（年月）のリストを取得する
      if (this.ym == null || this.ym === '') {
        this.ym = new Date()
      }

      this.updateStore('mode', define.LOGISTICS_CALENDAR_MODE.NORMAL)

      // 配送休業日一覧情報を取得する。
      await this.getDetailData()
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  mounted () {
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  methods: {
    /**
     *  現在の年月を処理
     */
    getNewDate (dateTime) {
      let year = dateTime.getFullYear()
      let month = dateTime.getMonth()
      month = month + 1
      month = month.toString().padStart(2, '0')
      let newDate = `${year}-${month}`
      return newDate
    },
    /**
     *  時間の選択を処理
     */
    onButtonClick (item, index) {
      if (item.color !== 1) {
        if (item.color === 0) {
          this.calendarList[index].color = 2
        } else {
          this.calendarList[index].color = 0
        }
      }
    },

    /**
     * 検索処理を実行します。
     */
    search: async function () {
      try {
        if (!await this.$validator.validate()) {
          return
        }
        this.$loadingService.show()
        const tdLists = this.storePath + '/tdLists'
        const currentPage = this.storePath + '/currentPage'
        // 一覧とページを初期化
        this.$store.dispatch({
          type: 'set',
          states: {
            [tdLists]: [],
            [currentPage]: 0
          }
        })
        await this.getDetailData()
      } catch (error) {
        this.$log.debug(error)
        this.$log.debug(JSON.stringify(error, null, 2))
        this.$notify.error({ error: error })
        throw error
      } finally {
        this.$loadingService.close()
      }
    },

    onChangeSite: async function () {
      try {
        this.$loadingService.show()
        // 選択肢（配送方法）のリストを取得する
        // 配送方法を取得する
        const queryQL = common.addGraphQlCondition(this.baseQuery, { siteCodes: [ this.siteCodeStr ] })
        // 配送方法検索APIを呼び出す
        const shippingMethods = await common.postGraphQl(queryQL)
        const methodList = shippingMethods.data.data.shippingMethods
        this.shippingMethodsOpts = []
        this.shippingMethodsOpts.push(
          {
            name: 'すべて'
          })
        methodList.forEach(item => {
          this.shippingMethodsOpts.push(
            {
              name: item.shippingMethod
            })
        })
        this.shippingMethodStr = this.shippingMethodsOpts[0].name

        // 配送休業日一覧情報を取得する。
        await this.getDetailData()
      } catch (error) {
        this.$notify.error({ error: error })
        throw error
      } finally {
        this.$loadingService.close()
      }
    },

    /**
     * 画面項目を生成.
     * @param {Object} path 項目KEY
     */
    createTextAreaProp (path) {
      // 配送方法
      if (path === 'shippingMethodCode') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'required|max:50', validateAs: '配送方法'
        }
      }
      // 休業日
      if (path === 'holidayAt') {
        return {
          type: 'DateTime', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'required', validateAs: '休業日'
        }
      }
      // 備考
      if (path === 'note') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'max:256', validateAs: '備考'
        }
      }
    },

    /**
     * Tooltipの項目を返却する.
     * @param {Object} row 注文情報
     * @return {Array}
     */
    getTooltipList (index) {
      return [
        {
          title: '削除',
          click: () => this.deleteHoliday(index)
        }
      ]
    },
    onBeforeUnload (event) {
      if (this.isChanged) {
        // 変更有の場合、再読み込み確認ダイアログを表示する.
        event.returnValue = 'changed'
      }
    },
    setStore (key, val) {
      this.$store.dispatch({
        type: 'set',
        states: { [key]: val }
      })
    },
    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.LOGISTICS_CALENDAR_MODE.EDIT:
          this.editHoliday()
          break
        default: {}
      }
    },

    /**
     * EDIT処理
     */
    async editHoliday () {
      // 編集モードに切り替える
      this.updateStore('mode', define.LOGISTICS_CALENDAR_MODE.EDIT)
      const newDate = this.getNewDate(this.ym)
      this.dateCalendar = newDate
      this.dateEdit(newDate)
      this.disabled = true
    },
    /**
     * date処理
     */
    async dateEdit (newDate) {
      this.calendarList = []
      let dateStr = newDate + '-01'
      let moday = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ]
      let days = 1
      let month
      let monthStr = dateStr.split('-')[1]
      if (monthStr.substring(0, 1) === '0') {
        month = monthStr.substring(1, 2)
      } else {
        month = monthStr
      }
      let years = dateStr.split('-')[0]
      // 閏年の判断
      let run = years % 4
      if (run !== 0) {
        moday[1] = 28
      } else {
        moday[1] = 29
      }
      let date = new Date(dateStr.replace(/-/g, '/'))
      // 当月設定
      date.setDate(1)
      let momatch = [0, 1, 2, 3, 4, 5, 6]
      let nowmonth = momatch[date.getDay()]
      for (let i = 1; i <= parseInt(nowmonth); i++) {
        let day = moday[nowmonth] - nowmonth + i
        this.calendarList.push({ isActive: 1, name: day, color: 1, holidayAt: years + '/' + month + '/' + day })
      }
      let preAll = parseInt(moday[month - 1] + nowmonth)
      for (let i = parseInt(nowmonth + 1); i <= preAll; i++) {
        if (i % 7 === 1 && i !== 1) {
          this.calendarList.push({ isActive: 2, name: '', color: 0 })
        }
        if (i === (days + nowmonth)) {
          this.calendarList.push({ isActive: 1, name: parseInt(i - nowmonth), color: 0, holidayAt: years + '/' + month + '/' + parseInt(i - nowmonth) })
        } else {
          this.calendarList.push({ isActive: 1, name: parseInt(i - nowmonth), color: 0, holidayAt: years + '/' + month + '/' + parseInt(i - nowmonth) })
        }
      }
      let j = 0
      for (let i = preAll; i < (parseInt(preAll / 7) + 1) * 7; i++) {
        if ((parseInt(preAll / 7) + 1) * 7 - i >= 7) {
          if (j === ((parseInt(preAll / 7) + 1) * 7 - i) % 7) {
            this.calendarList.push({ isActive: 2, name: '', color: 0 })
          }
        }
        j++
        this.calendarList.push({ isActive: 1, name: j, color: 1, holidayAt: years + '/' + month + '/' + j })
      }
      if (this.calendarList.length < 40) {
        let num
        if (this.calendarList[38].color === 1) {
          num = this.calendarList[38].name
        } else {
          num = 0
        }
        this.calendarList.push({ isActive: 2, name: '', color: 0 })
        for (let i = 0; i < 7; i++) {
          num++
          this.calendarList.push({ isActive: 1, name: num, color: 1, holidayAt: years + '/' + month + '/' + num })
        }
      }

    },
    /**
     * 新規配送休業日行を生成.
     */
    addRow () {
      const calendarList = this.calendarList
      for (const index in calendarList) {
        if (calendarList[index].color === 2) {
          const w1 = this.getMyDay(new Date(calendarList[index].holidayAt))
          let backColor = this.getBackColor(w1)
          if (this.shippingMethodStr === 'すべて') {
            for (const methods in this.shippingMethodsOpts) {
              if (this.shippingMethodsOpts[methods].name !== 'すべて') {
                // すべての場合、すでに一覧にある日のチェック
                if (this.allDateCheck(calendarList[index].holidayAt + '(' + w1 + ')' + this.shippingMethodsOpts[methods].name)) {
                  continue
                }
                this.holidayList.push({ node: { id: '', siteCode: this.siteCodeStr, shippingMethodCode: this.shippingMethodsOpts[methods].name, holidayAt: calendarList[index].holidayAt + '(' + w1 + ')', note: '', backColor: backColor, isActive: 1 } })
              }
            }
          } else {
            // すべて以外の場合、すでに一覧にある日のチェック
            if (this.dateCheck(calendarList[index].holidayAt + '(' + w1 + ')')) {
              continue
            }
            this.holidayList.push({ node: { id: '', siteCode: this.siteCodeStr, shippingMethodCode: this.shippingMethodStr, holidayAt: calendarList[index].holidayAt + '(' + w1 + ')', note: '', backColor: backColor, isActive: 1 } })
          }
        }
      }
      // フォーカス移動
      window.scroll({ top: this.$refs['table'].offsetHeight, behavior: 'smooth' })
    },
    /**
     * 背景色の設定を取得する
     */
    getBackColor (week) {
      if (week === '土') {
        return 1
      } else if (week === '日') {
        return 2
      } else {
        return 0
      }
    },
    /**
     * 曜日を取得する
     * @param {} date インデックス
     */
    getMyDay (date) {
      let week
      if (date.getDay() === 0) week = '日'
      if (date.getDay() === 1) week = '月'
      if (date.getDay() === 2) week = '火'
      if (date.getDay() === 3) week = '水'
      if (date.getDay() === 4) week = '木'
      if (date.getDay() === 5) week = '金'
      if (date.getDay() === 6) week = '土'
      return week
    },
    /**
     * すべての場合、すでに一覧にある日のチェック
     * @param {} holidayAt 配送休業日
     */
    allDateCheck (holidayAt) {
      let isExist = false
      for (const index in this.holidayList) {
        if (holidayAt === (this.holidayList[index].node.holidayAt + this.holidayList[index].node.shippingMethodCode)) {
          isExist = true
        }
      }
      return isExist
    },
    /**
     * すべて以外の場合、すでに一覧にある日のチェック
     * @param {} holidayAt 配送休業日
     */
    dateCheck (holidayAt) {
      let isExist = false
      for (const index in this.holidayList) {
        if (holidayAt === (this.holidayList[index].node.holidayAt)) {
          isExist = true
        }
      }
      return isExist
    },
    /**
     * 配送休業日削除を行う
     * @param {Number} index インデックス
     */
    deleteHoliday (index) {
      // 追加行を削除する場合、そのまま削除する
      if (this.holidayList[index].node.id === '') {
        this.holidayList.splice(index, 1)
      } else {
        this.holidayList[index].node.isActive = 0
      }
    },
    /**
     * 配送休業日編集保存を行う
     */
    async save () {
      // チェック処理
      if (!await this.$validator.validate()) {
        return
      }

      // 保存を行う
      this.$confirm('保存しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // 配送休業日編集パラメータの作成
          const data = this.buildRequestForUpdate()
          // 配送休業日編集保存を行う
          await this.updateHolidayApi(data)
          this.isChanged = false
          // 編集保存後、通常モードに切り替える
          this.updateStore('mode', define.LOGISTICS_CALENDAR_MODE.NORMAL)
          this.disabled = false
          // 日付順にソート
          this.holidayList.sort((a, b) => { if (new Date(a.node.holidayAt) < new Date(b.node.holidayAt)) { return -1 } else { return 1 } })
          this.$notify.success('保存しました。')
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else {
            common.addError(error, { msg: message.MSG_548() })
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {
        this.$notify.info('キャンセルしました。')
      })
    },
    /**
     * 配送休業日編集キャンセルを行う
     */
    async cancel () {
      const cancelEdit = () => {
        this.updateStore('mode', define.LOGISTICS_CALENDAR_MODE.NORMAL)
        this.isChanged = false
        this.disabled = false
      }
      if (!this.isChanged) {
        cancelEdit()
        return
      }
      this.$confirm('配送休業日の変更を破棄しますか？',
        define.MESSAGE_TITLE,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }
      ).then(() => {
        // キャンセル後、リスト再検索を行う
        this.getDetailData()
        cancelEdit()
      }).catch(() => {
      })
    },
    /**
     * 配送休業日一覧情報を取得する。
     */
    async getDetailData () {
      try {
        this.$loadingService.show()
        let shippingMethodCode = ''
        if (this.shippingMethodStr === 'すべて') {
          shippingMethodCode = ''
        } else {
          shippingMethodCode = this.shippingMethodStr
        }
        const newDate = this.getNewDate(this.ym)
        // 検索SQLを作成する
        const queryQL = common.addGraphQlCondition(this.listQuery, { siteCode: this.siteCodeStr, shippingMethodCode: shippingMethodCode, holidayAt: newDate })
        // 配送休業日検索APIを呼び出す
        const res = await common.postGraphQl(queryQL)
        // DBから画面の情報を取得
        this.holidayList = res.data.data.shipHolidays.edges
        for (const item of this.holidayList) {
          const w1 = this.getMyDay(new Date(item.node.holidayAt))
          const time = moment(item.node.holidayAt).tz('Asia/Tokyo').format('YYYY/M/D')
          item.node.holidayAt = time + '(' + w1 + ')'
          item.node.backColor = this.getBackColor(w1)
        }
        this.originHolidayList = _.cloneDeep(this.holidayList)
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * 一覧 から配送休業日更新APIのリクエストパラメータを作成する.
     * originDataとの差分のみ戻り値とする.
     */
    buildRequestForUpdate () {
      let requestData = []
      const diffList = compare.diff(this.originHolidayList, this.holidayList)
      for (const index in diffList) {
        const holidayAt = moment(this.holidayList[index].node.holidayAt, 'YYYY/MM/DD').utc().format()
        requestData.push(
          {
            siteCode: this.siteCodeStr, // サイトコード
            shippingCode: this.holidayList[index].node.shippingMethodCode, // 配送方法コード
            date: holidayAt, // 休業日
            note: this.holidayList[index].node.note, // 備考
            delete: this.holidayList[index].node.isActive === 0 ? 1 : 0 // 削除フラグ（削除）
          })
      }
      return requestData
    },
    /**
     * 配送休業日更新 APIを呼び出す
     */
    async updateHolidayApi (requestData) {
      const data = {
        shipHolidays: requestData
      }
      const url = config.SHIP_LOGISTICSCALENDAR_URL
      const method = 'post'
      const response = await common.apiAxios(url, { method, data })
      return response
    },
    /**
     * ストアの情報を更新する
     */
    updateStore (key, val) {
      const storeKey = `MasterLogisticsCalendar/${key}`
      this.$store.commit({
        type: 'set',
        states: {
          [storeKey]: val
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ship/MasterLogisticsCalendarTop.vue